import { Button } from "@etudescarre/ui";
import { useState } from "react";
import { useYardContext } from "@/providers/yard-context";
import { FicheQuestionForm } from "../components/fiche-question-form";

export function FichesQR() {
  const { hasContractType } = useYardContext();
  const [isRecording, setIsRecording] = useState(false);

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex shrink-0 items-center justify-between border-b border-zinc-200 px-4 py-4 dark:border-zinc-700">
        <h2 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100">
          {isRecording
            ? "Enregistrer une fiche question"
            : "Fiches Question / Réponse"}
        </h2>
        {!isRecording && hasContractType("travaux_n_1") && (
          <Button type="button" onClick={() => setIsRecording(true)}>
            Enregistrer une fiche question
          </Button>
        )}
      </div>
      <div className="min-h-0 flex-1 overflow-auto p-6">
        <div className="mx-auto max-w-3xl">
          {isRecording ? (
            <FicheQuestionForm onClose={() => setIsRecording(false)} />
          ) : (
            <p className="rounded-lg border border-zinc-200 bg-white p-6 text-sm text-zinc-600 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-400">
              Ce classeur listera les fiches question émises, filtrables par
              lot. Pour chaque fiche : N°, objet, date d'émission, question
              posée, lot concerné, pièces jointes, employé et contrat auteurs,
              ainsi que la réponse (le cas échéant) avec ses propres auteurs et
              pièces jointes.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
